<template>
  <div class="table-header">
    <div
      v-for="(item, $index) in column"
      :key="$index"
      class="table-header-item"
    >
      <div v-if="item.label" class="table-header-label">{{ $te(item.label) ? $t(item.label) : item.label }}</div>
      <div class="table-header-value">
        <RowCell
          v-if="item.render"
          :render="item.render"
          :value="row[item.prop]"
          :index="$index"
          :row="row"
        />
        <slot
          v-else-if="item.slot"
          :name="item.slot"
          :item="item"
          :value="row[item.prop]"
          :index="$index"
          :row="row"
        />
        <component
          :is="item.component"
          v-else-if="item.component"
          :value="row[item.prop]"
          :index="$index"
          :row="row"
          v-bind="getBinds(item)"
        />
        <div
          v-else-if="item.html"
          v-html="typeof item.html === 'function' ? item.html({ row, value: row[item.prop], index: $index }) : item.html"
        />
        <template v-else>
          {{ item.format ? item.format({ index: $index, value: row[item.prop], row }) : row[item.prop] === undefined ? '-' : row[item.prop] }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import RowCell from '@utils/table/components/row-cell'
export default {
  components: {
    RowCell
  },
  props: {
    column: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    row() {
      return this.data
    }
  },
  methods: {
    getBinds(item) {
      const copy = {}
      Object.keys(item).forEach(key => {
        if (!['component', 'event', 'on', 'row', 'column', 'index', 'state', 'message'].includes(key)) {
          copy[key] = item[key]
        }
      })
      return copy
    }
  }
}
</script>

<style lang="scss" scoped>
.table-header {
  display: flex;
  align-items: center;
  line-height: 14px;
  .table-header-item {
    padding: 0 20px;
    border-right: 1px solid #999999;
    height: 12px;
    display: inline-flex;
    align-items: center;
    line-height: 14px;
    &:first-of-type {
      padding-left: 0;
    }
    &:last-of-type {
      padding-right: 0;
      border-right: none;
    }
  }

  &-label {
    padding-right: 10px;
  }
  &-label, &-value {
    display: inline-block;
  }
  &-value{
    color: #333333;
  }
}
</style>
